import React from 'react'
import pt from 'prop-types'

const Magnifier = ({ fill = 'none', height = '23px', width = '23px' }) => (
  <svg width={width} height={height} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M22.3 20.7l.1.1 5.5 5.5c.5.5.5 1.2 0 1.7s-1.2.5-1.7 0l-5.5-5.5-.1-.1c-2.2 1.8-5 2.9-8 2.9C5.6 25.2 0 19.6 0 12.6S5.6 0 12.6 0s12.6 5.6 12.6 12.6c0 3.1-1.1 5.9-2.9 8.1zm-9.7 2.1c5.6 0 10.2-4.6 10.2-10.2S18.3 2.4 12.6 2.4 2.4 7 2.4 12.6 7 22.8 12.6 22.8z" />
  </svg>
)

Magnifier.propTypes = {
  fill: pt.string,
  height: pt.string,
  width: pt.string
}

export default Magnifier
